export default __webpack_public_path__ + "img/elements-rig.png?9d96";